/**
 * getImageSize
 * @param {File|string} val File 对象或者 base64 字符串
 */
export function getImageSize(val) {
  return new Promise((resolve, reject) => {
    if (val instanceof File || val instanceof Blob) {
      const reader = new FileReader()

      reader.addEventListener(
        'load',
        function () {
          const img = new Image()
          img.onload = () => {
            resolve({ width: img.width, height: img.height })
            img.onload = null
          }
          img.onerror = (err) => {
            reject(err)
          }
          img.src = reader.result
        },
        false,
      )

      reader.readAsDataURL(val)
      return
    }

    if (typeof val === 'string') {
      const img = new Image()
      img.onload = () => {
        resolve({ width: img.width, height: img.height })
        img.onload = null
      }
      img.onerror = (err) => {
        reject(err)
      }
      img.src = val
      return
    }

    reject(new Error('val 必须是 file 对象'))
  })
}

export function resizeImage({ dataURI, width, height }) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = dataURI

    const canvas = document.createElement('canvas')
    img.width = width
    img.height = height
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    img.onload = function () {
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL())
    }
    img.onerror = (err) => {
      reject(err)
    }
  })
}

export function loadImage(url, time) {
  return new Promise((resovle, reject) => {
    const image = new Image()
    image.onload = function () {
      resovle(image)
    }
    image.onerror = function () {
      reject()
    }
    image.crossOrigin = 'Anonymous'
    let stamp = /^data:image\/(png|jpeg|jpg);base64/.test(url)
      ? ''
      : '?time=' + Date.now()

    if (time === false) {
      stamp = ''
    }

    image.src = url + stamp
  })
}
